import React from 'react';

export default function DemoPreview() {
  return (
    <section id="demo" className="bg-[#0F172A] py-32">
      <div className="max-w-6xl mx-auto px-6">
        {/* Eyebrow */}
        <p className="text-center text-cyan-400 text-xs font-bold uppercase tracking-widest mb-3">
          See It in Action
        </p>

        {/* Heading */}
        <h2 className="text-center text-4xl md:text-5xl font-bold text-white mb-4">
          Your Command Center, Reimagined
        </h2>

        {/* Subtext */}
        <p className="text-center text-gray-400 text-lg mb-14">
          A real look inside the LoadApp dashboard.
        </p>

        {/* Browser mockup */}
        <div className="max-w-5xl mx-auto bg-gray-900 rounded-2xl overflow-hidden shadow-2xl border border-gray-700">
          {/* Toolbar */}
          <div className="h-10 bg-gray-800 flex items-center px-4 gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <span className="w-3 h-3 rounded-full bg-red-500 block" />
              <span className="w-3 h-3 rounded-full bg-yellow-400 block" />
              <span className="w-3 h-3 rounded-full bg-green-500 block" />
            </div>
            <div className="flex-1 bg-gray-700 rounded-md h-5 flex items-center px-3">
              <span className="text-gray-400 text-xs truncate">
                app.loadapp.com/dashboard
              </span>
            </div>
          </div>

          {/* Demo video */}
          <video
            className="w-full"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src="/videos/product-demo.webm" type="video/webm" />
            <source src="/videos/product-demo.mp4" type="video/mp4" />
          </video>
        </div>

        {/* CTA */}
        <div className="flex justify-center mt-14">
          <a
            href="/auth/register"
            className="
              inline-block
              px-8 py-4
              rounded-xl
              text-white font-semibold text-base
              bg-gradient-to-r from-blue-600 to-cyan-500
              shadow-[0_0_32px_rgba(6,182,212,0.45)]
              hover:shadow-[0_0_48px_rgba(6,182,212,0.65)]
              hover:scale-105
              transition-all duration-200
            "
          >
            Start Your Free Trial
          </a>
        </div>
      </div>
    </section>
  );
}
